import { MediaQueries, theme } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledEmbeddedCommunity = styled.div`
  margin-block: 16px;
  padding: 24px 16px;
  border-radius: 16px;
  background-color: ${theme.mbColors.toneGreen};
  ${MediaQueries.mbDown} {
    margin-inline: -16px;
  }
`

export const StyledCommunitySection = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  ${MediaQueries.mbDown} {
    flex-direction: column;
    gap: 8px;
  }
  .grow {
    flex-grow: 1;
  }
  .ask {
    white-space: nowrap;
  }
  .thumbnail {
    ${MediaQueries.mbDown} {
      width: 48px;
      height: 48px;
    }
    ${MediaQueries.mbUp} {
      width: 64px;
      height: 64px;
    }
    border-radius: 8px;
    &-header {
      ${MediaQueries.mbDown} {
        display: flex;
        /* justify-content: space-between; */
        gap: 16px;

        > div {
          display: flex;
          gap: 16px;
        }
      }
    }
  }
  .detail {
    width: 100%;
    flex-grow: 1;
    gap: 4px;
    display: flex;
    flex-direction: column;
    &-statistic {
      display: flex;
      gap: 16px;
    }
    &-tag {
      display: flex;
      gap: 8px;
      align-items: center;

      ${MediaQueries.mbDown} {
        flex-direction: column;
      }
      .ask {
        margin-left: auto;
      }
    }

    &-title {
      display: flex;
      gap: 10px;
      flex-direction: row;
    }
    &-header {
      display: flex;
      gap: 10px;
      flex-direction: row;
      padding-bottom: 12px;
    }
  }
  .mantine-Carousel-root {
    width: 100%;
  }
  a {
    text-decoration: none;
  }
`

export const StyledPostSection = styled.div`
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${theme.colors.neutral100};
  background-color: #ffffff;
  margin-top: 16px;

  ${MediaQueries.mbDown} {
    padding: 16px;
  }
  hr {
    margin-top: 24px;
    margin-bottom: 16px;
    border: 1px solid ${theme.colors.neutral100};
  }
  .join {
    margin-top: 16px;
  }
`
